import React from "react";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import "../../assets/css/Review.css";
import { cl1 } from "../../Constant";

function Review() {
    return (
        <>
            <Header />
            <input
                id="get-all-cat"
                type="hidden"
                value="<?php echo $review; ?>"
            />
            <section className="review">
                <div className="container">
                    <div className="row">
                        <div className="col-md-8">
                            <div className="d-flex">
                                <div className="profile-pic-section">
                                    <img
                                        id="giver-picture"
                                        className="user-profile-img giver-picture"
                                        src={cl1}
                                    />
                                    <div className="status-circle1"></div>
                                </div>
                                <div className="d-flex flex-column">
                                    <span className="d-flex">
                                        <h5
                                            id="giver-name"
                                            className="mt-2 mb-0 user-name blue giverChat-name"
                                        ></h5>
                                        <span className="giver-review-info ml-5 ">
                                            <i
                                                className="fa fa-map-marker mr-2"
                                                aria-hidden="true"
                                            ></i>
                                            <span
                                                id="giver-country"
                                                className="giver-country"
                                            >
                                                {" "}
                                            </span>
                                        </span>
                                        <span className="giver-review-info ml-5">
                                            <i
                                                className="fa fa-usd mr-2"
                                                aria-hidden="true"
                                            ></i>
                                            $<span id="giver-minAmount"> </span>{" "}
                                            - ${" "}
                                            <span id="giver-maxAmount">
                                                {" "}
                                                Per Hour
                                            </span>
                                        </span>
                                    </span>
                                    <p className="color-red mb-2 giver-service"></p>
                                    <small className="text-muted">
                                        Member Since -{" "}
                                        <span className="giver-created"></span>
                                    </small>
                                    <p
                                        id="giver-bio"
                                        className="giver-bio user-description"
                                    ></p>
                                    <div>
                                        <p className="text-left">
                                            <span className="fa fa-star star-active"></span>
                                            <span className="fa fa-star star-active"></span>
                                            <span className="fa fa-star star-active"></span>
                                            <span className="fa fa-star star-active"></span>
                                            <span className="fa fa-star star-active"></span>
                                            <span className="font-weight-bold ml-2 rating-by-customer"></span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div id="giver-sub-service" className="tags">
                                <span className="review-tags d-none">
                                    Kids trainer
                                </span>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="ml-auto review-btns">
                                <a
                                    id="hireNow-btn"
                                    href="#;"
                                    className="btn btn-secondary mr-2 hire_btn"
                                    data-toggle="modal"
                                    data-target="#exampleModalLong"
                                >
                                    <i
                                        className="fa fa-briefcase mr-1"
                                        aria-hidden="true"
                                    ></i>
                                    Hire Now
                                </a>
                                <a
                                    id="chatNow-btn"
                                    href="all-chats.php?id=<?= $review ?>"
                                    className="btn btn-primary chat-btn"
                                >
                                    <i
                                        className="fa fa-comment-o mr-1"
                                        aria-hidden="true"
                                    ></i>
                                    Chat Now
                                </a>
                                {/* <!--                        <p className="pt-5 pt-sm-3 availability-link">Want to check availability? <a href="" className="check-availability">Click Here</a> </p>--> */}
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div className="row">
                        <div className="col-md-12 d-flex flex-column">
                            <h5 className="home-cleaning-heading mt-4 giver-service"></h5>
                            <p className="home-cleaning-text giver-bio"></p>
                        </div>
                        <div className="col-md-8 d-flex">
                            <div className="rating-box">
                                <span className="review-feedback pt-4">
                                    <span className="review-count totalRating-by-customer"></span>{" "}
                                    Review and Feedbacks{" "}
                                </span>
                                <div className="rating-star">
                                    {" "}
                                    <span className="fa fa-star star-active mx-1"></span>
                                    <span className="fa fa-star star-active mx-1"></span>
                                    <span className="fa fa-star star-active mx-1"></span>
                                    <span className="fa fa-star star-active mx-1"></span>
                                    <span className="fa fa-star star-active mx-1"></span>
                                    <span className="mx-1 rating-by-customer">
                                        5.0
                                    </span>
                                </div>
                            </div>
                            <div className="vl"></div>
                            <div className="rating-bar0 justify-content-center">
                                <table className="text-left">
                                    <tr>
                                        <td className="rating-bar">
                                            <div className="bar-container">
                                                <div className="bar-5"></div>
                                            </div>
                                        </td>
                                        <td id="rating5" className="text-right">
                                            0
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="rating-bar">
                                            <div className="bar-container">
                                                <div className="bar-4"></div>
                                            </div>
                                        </td>
                                        <td id="rating4" className="text-right">
                                            0
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="rating-bar">
                                            <div className="bar-container">
                                                <div className="bar-3"></div>
                                            </div>
                                        </td>
                                        <td id="rating3" className="text-right">
                                            0
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="rating-bar">
                                            <div className="bar-container">
                                                <div className="bar-2"></div>
                                            </div>
                                        </td>
                                        <td id="rating2" className="text-right">
                                            0
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="rating-bar">
                                            <div className="bar-container">
                                                <div className="bar-1"></div>
                                            </div>
                                        </td>
                                        <td id="rating1" className="text-right">
                                            0
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                        <div
                            id="all-customer-reviews"
                            className="col-md-12 mt-5"
                        >
                            {/* <!--                    <div className="col-md-12 d-flex mt-5" style="flex-wrap: wrap;">-->
                <!--                        <div className="profile-pic-section" style="flex: 1;">-->
                <!--                            <img className="profile-pic-list" src="./img/team/profile-img.jpeg">-->
                <!--                        </div>-->
                <!--                        <div className="d-flex flex-column" style="flex: 30;">-->
                <!--                            <span className="d-flex"><h5 className="mt-2 mb-0 user-name">John Doe</h5>-->
                <!--                                <span className="user-info-list ml-3 ">Baby Sitting</span>-->
                <!--                            </span>-->
                <!--                            <p className="user-description-list">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam</p>-->
                <!--                        </div>-->
                <!--                        <div className="ml-auto" style="flex: 2;">-->
                <!--                            <p className="text-muted days-ago">5 Days ago</p>-->
                <!--                        </div>-->
                <!--                        <div className="separator">-->
                <!--                            <hr>-->
                <!--                        </div>-->
                <!--                    </div>--> */}
                        </div>
                        <div className="col-md-12">
                            <div className="show-more text-center mt-5">
                                <a className="show-more-btn ">Show More</a>
                            </div>
                        </div>
                    </div>
                </div>

                {/* <!-- Modal --> */}
                <div
                    className="modal fade"
                    id="exampleModalLong"
                    tabindex="-1"
                    role="dialog"
                    aria-labelledby="exampleModalLongTitle"
                    aria-hidden="true"
                >
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-body">
                                <div className="col-md-12 d-flex mt-5">
                                    <div className="d-flex flex-column">
                                        <span className="d-flex">
                                            <h5 className="mt-2 mb-0 user-name">
                                                Create a custom offer
                                            </h5>
                                        </span>
                                        <p
                                            id="giver-bio"
                                            className="form-description"
                                        >
                                            Lorem ipsum dolor sit amet,
                                            consectetur adipiscing elit, sed do
                                            eiusmod tempor incididunt ut labore
                                            et dolore magna aliqua. Ut enim ad
                                            minim veniam
                                        </p>
                                    </div>
                                    <div className="form-user-info">
                                        <p className="text-muted form-request">
                                            submitting requesting to
                                        </p>
                                        <div className="d-flex border form-user-details">
                                            <div className="profile-pic-section">
                                                <img
                                                    id="giver-picture"
                                                    className="giver-picture form-pic"
                                                    src="./img/team/profile-img.jpeg"
                                                />
                                                {/* <!--                                        <img className="form-pic" src="./img/team/profile-img.jpeg">--> */}
                                            </div>
                                            <div className="d-flex flex-column">
                                                <p className="form-user-title color-red mb-0 user-name giverChat-name">
                                                    Consectetur
                                                </p>
                                                <p className="form-user-desc color-red mb-2 giver-service">
                                                    Child Care
                                                </p>
                                            </div>
                                            <div className="form-rating-sec">
                                                <span className="fa fa-star star-active"></span>
                                                <span className="font-weight-bold ml-2 form-rating">
                                                    4.5
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="container">
                                    <form
                                        id="hiring-request"
                                        action=""
                                        method=""
                                    >
                                        {/* <!--Service--> */}
                                        <div className="d-flex">
                                            <h6 className="form-title mt-4">
                                                Choose Service
                                            </h6>
                                            <hr className="horizontal-line" />
                                        </div>
                                        <div className="form-container mt-4">
                                            <div className="field-box">
                                                <label
                                                    htmlFor=""
                                                    className="col-form-label form-label"
                                                >
                                                    Choose main category
                                                </label>
                                            </div>
                                            <div className="field-box ml-auto">
                                                <select
                                                    id="care-giver-category"
                                                    className="form-control select-form"
                                                >
                                                    {/* <!--                                        <option>Select from main category</option>--> */}
                                                    <option className="giver-service"></option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="form-container mt-4">
                                            <div className="field-box">
                                                <label
                                                    htmlFor=""
                                                    className="col-form-label form-label"
                                                >
                                                    Choose Sub category
                                                </label>
                                            </div>
                                            <div className="field-box ml-auto">
                                                <select
                                                    id="care-giver-sub-service"
                                                    className="form-control select-form post-careGiver-subCategory"
                                                >
                                                    <option>
                                                        Select from sub category
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                        {/* <!--Pricing--> */}
                                        <div className="d-flex">
                                            <h6 className="form-title mt-4">
                                                Pricing
                                            </h6>
                                            <hr className="horizontal-line" />
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input
                                                type="hidden"
                                                id="3"
                                                className="unit-type-hourly-lumsum form-check-input"
                                                type="checkbox"
                                                name="per-hour"
                                                id="inlineCheckbox1"
                                                value="3"
                                                required
                                            />
                                            {/* <!--                                    <label className="form-check-label checkbox-label" htmlFor="inlineCheckbox1">Per Hour</label>--> */}
                                        </div>
                                        {/* <!--                                <div className="form-check form-check-inline">-->
                            <!--                                    <input id="6" className="unit-type-hourly-lumsum form-check-input" type="radio" name="per-hour" id="inlineCheckbox2" value="6">-->
                            <!--                                    <label className="form-check-label checkbox-label" htmlFor="inlineCheckbox2">Lumspum</label>-->
                            <!--                                </div>--> */}
                                        <div className="form-container">
                                            <div className="field-box">
                                                <label
                                                    htmlFor=""
                                                    className="col-form-label form-label"
                                                >
                                                    Add Amount
                                                </label>
                                            </div>
                                            <div className="field-box ml-auto">
                                                <input
                                                    id="careGiver-amount"
                                                    type="text"
                                                    className="form-control select-form"
                                                    placeholder="Enter Amount Here"
                                                    required
                                                />
                                            </div>
                                        </div>
                                        {/* <!--Description--> */}
                                        <div className="d-flex">
                                            <h6 className="form-title mt-4">
                                                Description
                                            </h6>
                                            <hr className="horizontal-line" />
                                        </div>
                                        <div className="form-container mt-4">
                                            <div className="field-box">
                                                <label
                                                    htmlFor=""
                                                    className="col-form-label form-label"
                                                >
                                                    Describe the task in detail
                                                </label>
                                            </div>
                                            <div className="field-box ml-auto">
                                                <textarea
                                                    id="careGiver-note"
                                                    type="text"
                                                    className="form-control select-form"
                                                    placeholder="Max 500 words in Description"
                                                    required
                                                ></textarea>
                                            </div>
                                        </div>
                                        {/* <!--Service Period--> */}
                                        <div className="d-flex">
                                            <h6 className="form-title mt-4">
                                                Service Period
                                            </h6>
                                            <hr className="horizontal-line" />
                                        </div>
                                        <div className="form-container mt-4">
                                            <div className="field-box">
                                                <label
                                                    htmlFor=""
                                                    className="col-form-label form-label"
                                                >
                                                    Start Date
                                                </label>
                                            </div>
                                            <div className="field-box ml-auto">
                                                <input
                                                    id="careGiver-date"
                                                    type="date"
                                                    className="form-control select-form care-giver-book-date"
                                                    placeholder=""
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="form-container mt-4">
                                            <div className="field-box">
                                                <label
                                                    htmlFor=""
                                                    className="col-form-label form-label"
                                                >
                                                    Start Time
                                                </label>
                                            </div>
                                            <div className="field-box ml-auto">
                                                <input
                                                    id="careGiver-start-time"
                                                    type="time"
                                                    className="form-control select-form"
                                                    placeholder=""
                                                    required
                                                />
                                            </div>
                                        </div>
                                        {/* <!--                            <div className="form-container mt-4">-->
<!--                                <div className="field-box">-->
<!--                                    <label htmlFor="" className="col-form-label form-label">Status</label>-->
<!--                                </div>-->
<!--                                <div className="field-box ml-auto">-->
<!--                                    <select id="" className="careGiver-status form-control select-form">-->
<!--                                        <option value="7">Pending</option>-->
<!--                                        <option value="10">Scheduled</option>-->
<!--                                    </select>-->
<!--                                </div>-->
<!--                            </div>--> */}
                                        <div className="form-container mt-4">
                                            <div className="field-box">
                                                <label
                                                    htmlFor=""
                                                    className="col-form-label form-label"
                                                >
                                                    Address
                                                </label>
                                            </div>
                                            <div className="field-box ml-auto">
                                                <input
                                                    id="careGiver-address"
                                                    type="text"
                                                    className="form-control select-form"
                                                    placeholder=""
                                                    required
                                                />
                                            </div>
                                        </div>
                                        {/* <!--                                <p className="submit-info">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco labo</p>-->
                            <!--Submit Button--> */}
                                        <div className="form-group row">
                                            <div className="col-sm-12">
                                                {/* <!--                                        <div className="form-check form-check-inline mt-3">-->
                                    <!--                                            <input className="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">-->
                                    <!--                                            <label className="form-check-label checkbox-label" htmlFor="inlineCheckbox1">I'm not a robot</label>-->
                                    <!--                                        </div>-->
                                    <!--                                        <a href="#;" className="btn btn-secondary float-right">Submit Hiring Request</a>--> */}
                                                <button className="btn btn-secondary float-right mt-3">
                                                    Submit Hiring Request
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
}

export default Review;
